import styled from 'styled-components';
import React, { Fragment } from 'react';

import { spinnerStyles } from '../../styles/';

export const Spinner = styled.div`
  ${spinnerStyles};
  position: ${props => props.position || 'absolute'};
  width: ${props => props.width}px;
  height: ${props => props.height}px;
  margin-top: -${props => props.width / 2}px;
  margin-left: -${props => props.width / 2}px;
  border: ${props => props.borderWidth}px solid transparent;
  border-top-color: ${props => props.theme.colors.tangerinePrimary};
`;

Spinner.defaultProps = {
  width: 50,
  height: 50,
  borderWidth: 4,
};

export default Spinner;

const SpinnerBackground = styled.div`
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0.5;
  position: absolute;
  background-color: ${({ theme }) => theme.colors.white};
`;

export const SpinnerWithBackground = props => (
  <Fragment>
    <SpinnerBackground />
    <Spinner {...props} />
  </Fragment>
);

const SpinnerWrapper = styled.div`
  position: relative;
`;

export const InfiniteScrollSpinner = () => (
  <SpinnerWrapper>
    <Spinner style={{ top: 50 }} width="40" height="40" borderWidth="3" />
  </SpinnerWrapper>
);

export const LoadingMore = styled.div`
  ${spinnerStyles};
  width: ${props => props.width}px;
  height: ${props => props.height}px;
  position: ${props => props.position || 'static'};
  margin: ${props => props.margin};
  border: ${props => props.borderWidth}px solid transparent;
  border-top-color: ${props => props.color || props.theme.colors.tangerinePrimary};
`;

LoadingMore.defaultProps = {
  width: 30,
  height: 30,
  borderWidth: 3,
  margin: '5px auto',
};



// WEBPACK FOOTER //
// ./src/components/ui-helpers/spinner.js